module.exports = "https://cdn-social.hiplatform.com/images/64f9f64881b568898d01a5774f8f43cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/emojis/cool.svg
// module id = I2+J
// module chunks = 0